import { render, staticRenderFns } from "./trans-player.vue?vue&type=template&id=106ba9e6&scoped=true&"
import script from "./trans-player.vue?vue&type=script&lang=js&"
export * from "./trans-player.vue?vue&type=script&lang=js&"
import style0 from "./trans-player.vue?vue&type=style&index=0&id=106ba9e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ba9e6",
  null
  
)

export default component.exports